const dictionary: Record<string, string> = {
  id: "ID",
  userId: "ユーザーID",
  requestNumber: "申請番号",
  email: "メールアドレス",
  userName: "ユーザー名",
  applicantName: "代表者名",
  applicantNameKana: "代表者フリガナ",
  phoneNumber: "電話番号",
  faxNumber: "FAX 番号",
  requestDelete: "退会申請",
  isProcessed: "処理済み",
  createdAt: "作成日",
  updatedAt: "更新日",
};

export function getJaDisplayName(varName: string): string {
  return dictionary[varName] || varName;
}
